import React from 'react';

const MerciPage: React.FC = () => {
    return (
        <div className="container" style={{ textAlign: 'center' }}>
            <h1>Thank you, your form is submitted !</h1>
            <p>If you have any question, please contact your "gestionnaire de département", through the generic email address of your department.</p>
        </div>
    );
};

export default MerciPage;